export const stateTypes = Object.freeze({
    POSITION: 'position',
    NAME: 'name',
    TEE: 'tee',
    TO_PAR: 'to-par',
    HOLE: 'hole',
    TODAY: 'today'
});

export const noFavoriteMessage = {
    title: 'Favourite players',
    body: 'You don’t have any favourites added yet, click on the player\'s star button to add them.'
};
